import {FORM_ERROR} from "../../app/constants/messages";

export function renderFormErrorMessages() {
    return FORM_ERROR('UDP origin entry point')
}
